import { WHATSAPP_DISPLAY, EMAIL } from "../lib/whatsapp";

const lignes = [
  {
    desc: "Mise à disposition de serveurs / serveuses — tenue d'apparat incluse (chemise blanche, gilet noir, nœud papillon)",
    qty: "6 pers. × 8 h",
    pu: "50 €/h",
    total: "2 400 €",
  },
  {
    desc: "Maître d'hôtel — coordination de la brigade, accueil protocolaire et gestion du service",
    qty: "1 pers. × 8 h",
    pu: "70 €/h",
    total: "560 €",
  },
  {
    desc: "Frais de déplacement — forfait (Île-de-France)",
    qty: "1",
    pu: "100 €",
    total: "100 €",
  },
];

const conditions = [
  "Acompte de 60 % à la réservation (soit 1 836 €), exigé avant la signature du contrat. La totalité du solde est à régler au plus tard 24 heures avant l'événement.",
  "Aucun remboursement n'est prévu en cas d'annulation, quel que soit le délai.",
  "Tout dépassement horaire est facturé au taux horaire en vigueur, par tranche d'heure entamée.",
  "Les frais de déplacement hors Île-de-France (France et Europe) restent à la charge du client et font l'objet d'une ligne dédiée.",
  "Devis valable 30 jours à compter de sa date d'émission. TVA non applicable, art. 293 B du CGI.",
];

const DevisDoc = () => (
  <div id="devis-print" data-testid="devis-doc" className="mx-auto w-full max-w-[820px] bg-white p-10 text-[#0a0a0a] shadow-2xl lg:p-14">
    <div className="flex items-start justify-between border-b-2 border-[#0a0a0a] pb-8">
      <div>
        <p className="font-display text-5xl tracking-tight">
          FK<span className="text-[#aa8c2c]">.</span>
        </p>
        <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.4em] text-[#aa8c2c]">Conseil &amp; Événement</p>
        <p className="mt-4 text-xs leading-relaxed text-[#0a0a0a]/60">
          Service d'exception — Serveurs · Serveuses · Maîtres d'hôtel
          <br />
          Basés en Île-de-France — Déplacements France &amp; Europe
        </p>
      </div>
      <div className="text-right text-xs leading-relaxed text-[#0a0a0a]/60">
        <p className="font-display text-3xl tracking-tight text-[#0a0a0a]">DEVIS</p>
        <p className="mt-1 font-semibold">N° DEV-2026-001</p>
        <p>Émis le 03 août 2026</p>
        <p>Valable 30 jours</p>
      </div>
    </div>

    <div className="mt-8 grid gap-6 sm:grid-cols-2">
      <div className="rounded-xl border border-[#0a0a0a]/10 p-6">
        <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#aa8c2c]">Client</p>
        <p className="mt-3 text-sm font-semibold">M. &amp; Mme Dupont</p>
        <p className="mt-1 text-xs leading-relaxed text-[#0a0a0a]/60">
          Mariage — 150 invités
          <br />
          Salle Baccara, Île-de-France
          <br />
          Samedi 25 juillet 2026
        </p>
      </div>
      <div className="rounded-xl border border-[#0a0a0a]/10 p-6">
        <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#aa8c2c]">Contact</p>
        <p className="mt-3 text-sm font-semibold">FK Conseil &amp; Événement</p>
        <p className="mt-1 text-xs leading-relaxed text-[#0a0a0a]/60">
          WhatsApp : {WHATSAPP_DISPLAY}
          <br />
          Email : {EMAIL}
        </p>
      </div>
    </div>

    <table className="mt-10 w-full text-left text-sm" data-testid="devis-lines">
      <thead>
        <tr className="border-b-2 border-[#0a0a0a] text-[10px] font-bold uppercase tracking-[0.2em] text-[#0a0a0a]/50">
          <th className="py-3 pr-4">Prestation</th>
          <th className="py-3 pr-4">Quantité</th>
          <th className="py-3 pr-4">Prix unitaire</th>
          <th className="py-3 text-right">Total</th>
        </tr>
      </thead>
      <tbody>
        {lignes.map((l) => (
          <tr key={l.desc} className="border-b border-[#0a0a0a]/10 align-top">
            <td className="py-4 pr-4 text-[13px] leading-relaxed">{l.desc}</td>
            <td className="whitespace-nowrap py-4 pr-4 text-[13px]">{l.qty}</td>
            <td className="whitespace-nowrap py-4 pr-4 text-[13px]">{l.pu}</td>
            <td className="whitespace-nowrap py-4 text-right font-semibold">{l.total}</td>
          </tr>
        ))}
      </tbody>
    </table>

    <div className="mt-6 flex justify-end">
      <div className="w-64 rounded-xl bg-[#0a0a0a] p-6 text-white">
        <div className="flex justify-between text-sm">
          <span className="text-white/60">Total HT</span>
          <span className="font-display text-2xl text-[#d4af37]" data-testid="devis-total">3 060 €</span>
        </div>
        <p className="mt-3 text-[10px] leading-relaxed text-white/40">
          TVA non applicable, art. 293 B du CGI
        </p>
      </div>
    </div>

    <div className="mt-10">
      <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-[#aa8c2c]">Conditions de versement</p>
      <ul className="mt-4 space-y-2.5">
        {conditions.map((c) => (
          <li key={c} className="flex items-start gap-3 text-xs leading-relaxed text-[#0a0a0a]/70">
            <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rotate-45 bg-[#aa8c2c]" />
            {c}
          </li>
        ))}
      </ul>
    </div>

    <div className="mt-12 grid gap-8 border-t border-[#0a0a0a]/10 pt-8 sm:grid-cols-2">
      <div className="text-xs text-[#0a0a0a]/60">
        <p className="font-bold uppercase tracking-[0.25em] text-[#0a0a0a]">Bon pour accord</p>
        <p className="mt-2">Date et signature du client, précédées de la mention « lu et approuvé » :</p>
        <div className="mt-6 h-24 rounded-xl border border-dashed border-[#0a0a0a]/25" />
      </div>
      <div className="text-xs text-[#0a0a0a]/60">
        <p className="font-bold uppercase tracking-[0.25em] text-[#0a0a0a]">FK Conseil &amp; Événement</p>
        <p className="mt-2">Signature :</p>
        <div className="mt-6 h-24 rounded-xl border border-dashed border-[#0a0a0a]/25" />
      </div>
    </div>
  </div>
);

export default function ModeleDevis() {
  return (
    <div className="min-h-screen bg-[#141414] px-6 py-20" data-testid="modele-devis-page">
      <style>{`
        @media print {
          body * { visibility: hidden; }
          #devis-print, #devis-print * { visibility: visible; }
          #devis-print { position: absolute; inset: 0; width: 210mm; max-width: 210mm; margin: 0 auto; box-shadow: none; }
        }
      `}</style>
      <div className="mx-auto max-w-4xl">
        <a href="/" data-testid="devis-back-link" className="text-xs uppercase tracking-[0.3em] text-white/40 transition-colors hover:text-gold">
          ← Retour au site
        </a>
        <h1 className="mt-8 font-display text-4xl tracking-tight text-white sm:text-5xl">
          Modèle de devis <em className="italic text-gold">pré-rempli</em>
        </h1>
        <p className="mt-4 text-sm text-white/50">
          Format A4 — logo, tarifs, conditions de versement et zone « bon pour accord » inclus. Imprimez-le puis adaptez les montants à chaque client.
        </p>
        <div className="mt-14">
          <DevisDoc />
        </div>
        <div className="mt-14 flex flex-wrap gap-4">
          <button
            type="button"
            onClick={() => window.print()}
            data-testid="devis-print-button"
            className="rounded-full bg-gold px-8 py-4 text-xs font-bold uppercase tracking-[0.25em] text-[#0a0a0a] transition-transform duration-300 hover:scale-[1.03]"
          >
            Imprimer le devis
          </button>
          <a
            href={`${process.env.REACT_APP_BACKEND_URL}/api/devis-modele.pdf`}
            data-testid="devis-pdf-download"
            className="rounded-full border border-gold/60 px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-gold transition-colors duration-300 hover:bg-gold hover:text-[#0a0a0a]"
          >
            Télécharger le PDF
          </a>
          <a
            href="/flyer"
            data-testid="devis-flyer-link"
            className="rounded-full border border-white/20 px-8 py-4 text-xs font-semibold uppercase tracking-[0.25em] text-white/80 transition-colors duration-300 hover:border-gold hover:text-gold"
          >
            Voir le flyer A5
          </a>
        </div>
      </div>
    </div>
  );
}
